import * as React from "react"
const SvgLandingPage = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 20.286q-.824 0-1.413-.588A1.93 1.93 0 0 1 3 18.286v-12q0-.825.587-1.413A1.93 1.93 0 0 1 5 4.286h14q.824 0 1.413.587.587.588.587 1.413v12q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588zm0-2h8.5v-3.5H5zm10.5 0H19v-9h-3.5zM5 12.786h8.5v-3.5H5z" />
  </svg>
)
export default SvgLandingPage
